import { LifeCycle } from '@beecode/msh-node-app'
import { InitiateCommonParams, initiateCommon } from '@zeus/common'
import { initiateReactCommon } from '@zeus/react-common'
import { LocalStorageStrategy } from '@zeus/react-common/lib/lib/storage-strategy/local-storage-strategy'
import { authRepo } from 'src/business/repo/auth-repo'
import { logger } from 'src/util/logger'

export class CommonLibInitiable extends LifeCycle {
  public constructor() {
    super({ name: 'Common Lib Setup' })
  }

  protected async _createFn(): Promise<void> {
    const commonInitiateParams: InitiateCommonParams = {
      loggerFactory: logger,
    }
    initiateCommon(commonInitiateParams)
    initiateReactCommon({
      config: { dummyPlaceholder: true },
      commonInitiateParams,
      storageStrategy: new LocalStorageStrategy(),
      authRepo: authRepo(),
    })
  }

  protected _destroyFn(): Promise<void> {
    return Promise.resolve(undefined)
  }
}
